export default __webpack_public_path__ + "static/media/profile.d068efe1.png";